import {BASE_URL} from "../config/api";

export const addUser = async (payload) => {
  const response = await fetch(`${BASE_URL}/user/createUser`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to add user");
  }

  return await response.json();
};


export const fetchAllUsers = async (departmentId = null) => {
  const url = departmentId
    ? `${BASE_URL}/user/fetchAllUsers?department_id=${departmentId}`
    : `${BASE_URL}/user/fetchAllUsers`;

  const response = await fetch(url);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch users");
  }

  const data = await response.json();
  return data.users;
};


export const fetchUserById = async (id) => {
  const response = await fetch(`${BASE_URL}/user/fetchUserById/${id}`);
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch user");
  }

  const data = await response.json();
  return data.user;
};

export const updateUser = async (id, formData) => {
  const response = await fetch(`${BASE_URL}/user/updateUser/${id}`, {
    method: "POST",
    body: formData,
  });

  const contentType = response.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    const text = await response.text();
    throw new Error("Server did not return JSON:\n" + text);
  }

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to update user");
  }

  return await response.json();
};


export const updateUserAtProfile = async (id, formData) => {
  const response = await fetch(`${BASE_URL}/user/updateUserAtProfile/${id}`, {
    method: "POST",
    body: formData,
  });

  const contentType = response.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    const text = await response.text();
    throw new Error("Server did not return JSON:\n" + text);
  }

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to update user");
  }

  return await response.json();
};
